import React from 'react';

export const Image = props => {
  return <img alt="Alternate Text" {...props} />;
};
